module.exports = __webpack_public_path__ + "img/4_uk.bec5a569.svg";